import useForm from './useForm';
import TextField from 'components/TextField';
import styles from './blogs.module.scss';
import Button from 'components/Button';
import {Controller} from 'react-hook-form';
import Typography from 'components/Typography';
import {TemplateStatus} from '../TemplateList/useTemplate';
import cx from 'classnames';
import 'components/CkeditorTemplate/style.scss';

function TemplateForm() {
  const {loading, control, errors, createHandler, setFieldValue} = useForm();

  return (
    <>
      <div className={styles.status}>
        <Typography style={{marginBottom: 4, fontSize: 16}} variant="p">
          Published:
        </Typography>
        <TemplateStatus
          id={''}
          active={true}
          onChangeStatus={(value) => {
            setFieldValue('is_active', value);
          }}
        />
      </div>
      <div className={styles.container}>
        <div className={styles.left}>
          <Controller
            control={control}
            name="title"
            rules={{required: 'Required'}}
            render={({field}) => (
              <TextField
                label="Title"
                placeholder="Title"
                value={field.value}
                wrapperClass={styles.title}
                onChange={field.onChange}
                error={errors.title?.message}
              />
            )}
          />
          <Controller
            control={control}
            name="content"
            rules={{required: 'Required'}}
            render={({field}) => (
              <div
                className={cx(
                  'field-container ant-row ant-form-item',
                  styles.textareaWrapper
                )}
              >
                <div className={'ant-label'}>Content:</div>
                <textarea
                  className={styles.messageTextarea}
                  placeholder="Message"
                  value={field.value}
                  onChange={field.onChange}
                />
              </div>
            )}
          />
          <Button
            loading={loading}
            onClick={createHandler}
            color="blue"
            style={{width: 'auto', marginLeft: 'auto', marginTop: 30}}
          >
            Create
          </Button>
        </div>
      </div>
    </>
  );
}

export default TemplateForm;
